(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/category-title.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/category-title.js');
"use strict";

const {
  useHistory
} = ReactRouterDOM;
const Icon = svs.ui.ReactIcon;
const CategoryTitle = _ref => {
  let {
    category,
    className = ''
  } = _ref;
  const {
    CATEGORY
  } = svs.eInstant.constants.ROUTES;
  const {
    title,
    urlPath,
    icon,
    favorites = false
  } = category;
  const url = favorites ? urlPath : "".concat(CATEGORY.replace(':categoryId', urlPath));
  const history = useHistory();
  if (urlPath) {
    return React.createElement("a", {
      "aria-label": "G\xE5 till ".concat(title),
      href: url,
      onClick: e => {
        e.preventDefault();
        history.push(url);
      }
    }, React.createElement("div", {
      className: "u-flex u-flex-align-items-center f-body ".concat(className)
    }, React.createElement(Icon, {
      color: "fc-fler-lotter-new-700",
      icon: icon,
      size: 500
    }), React.createElement("h2", {
      className: "h2 tickets-einstant-categories-title fc-fler-lotter-new-700 margin-0 padding-h-1"
    }, title), React.createElement(Icon, {
      color: "fc-fler-lotter-new-700",
      icon: "arrow-right",
      size: 500
    })));
  }
  return React.createElement("div", {
    className: "u-flex u-flex-align-items-center f-body ".concat(className)
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700",
    icon: icon,
    size: 500
  }), React.createElement("h2", {
    className: "h2 tickets-einstant-categories-title fc-fler-lotter-new-700 margin-0 padding-h-1"
  }, title));
};
setGlobal('svs.eInstant.shared.components.CategoryTitle', CategoryTitle);

 })(window);